import { stringLiteral } from '@execonline-inc/decoders';
import { Decoder, array, field, oneOf, succeed } from 'jsonous';
import { resourceDecoder } from '../../../../Resource/Decoders';
import { Resource } from '../../../../Resource/Types';

// Types that match the server response
export type TaskKind =
  | 'create-learning-collection'
  | 'publish-learning-collection'
  | 'invite-participants'
  | 'onboard-participants'
  | 'create-user-group'
  | 'add-participants-to-group'
  | 'generate-deep-links'
  | 'learning-collection-each-license';

export type TaskStatus = 'complete' | 'incomplete';

export interface Task {
  kind: TaskKind;
  status: TaskStatus;
}

export interface AdminTasks {
  taskList: Task[]; // Only this field name is camelCase
}

// Decoders for server types
const taskKindFromServerDecoder: Decoder<TaskKind> = oneOf([
  stringLiteral<TaskKind>('create-learning-collection'),
  stringLiteral<TaskKind>('publish-learning-collection'),
  stringLiteral<TaskKind>('invite-participants'),
  stringLiteral<TaskKind>('onboard-participants'),
  stringLiteral<TaskKind>('create-user-group'),
  stringLiteral<TaskKind>('add-participants-to-group'),
  stringLiteral<TaskKind>('generate-deep-links'),
  stringLiteral<TaskKind>('learning-collection-each-license'),
]);

const taskStatusDecoder: Decoder<TaskStatus> = oneOf([
  stringLiteral<TaskStatus>('complete'),
  stringLiteral<TaskStatus>('incomplete'),
]);

const taskFromServerDecoder: Decoder<Task> = succeed({})
  .assign('kind', field('kind', taskKindFromServerDecoder))
  .assign('status', field('status', taskStatusDecoder));

const adminTasksFromServerDecoder: Decoder<AdminTasks> = succeed({}).assign(
  'taskList',
  field('task_list', array(taskFromServerDecoder)),
);

export const adminTasksResourceDecoder: Decoder<Resource<AdminTasks>> = resourceDecoder(
  adminTasksFromServerDecoder,
);
